import React, {createContext, useState} from 'react';

export const VouchersFormContext = createContext();

export const VouchersFormProvider = ({ children }) => {
	const [vouchersForm, setVouchersForm] = useState('regular');
	const [giftCardInFlight, setGiftCardInFlight] = useState({});
	const [appliedVouchersList, setAppliedVouchersList] = useState({});
	const [appliedGiftCardsList, setAppliedGiftCardsList] = useState({});
	const [validPromotions, setValidPromotions] = useState([]);
	const [allPromotions, setAllPromotions] = useState([]);
	const [appliedPromotionsList, setAppliedPromotionsList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	return (
		<VouchersFormContext.Provider value={{
			vouchersForm,
			setVouchersForm,
			appliedVouchersList,
			setAppliedVouchersList,
			giftCardInFlight,
			setGiftCardInFlight,
			appliedGiftCardsList,
			setAppliedGiftCardsList,
			validPromotions,
			setValidPromotions,
			allPromotions,
			setAllPromotions,
			appliedPromotionsList,
			setAppliedPromotionsList,
			isLoading,
			setIsLoading
		}}>
			{children}
		</VouchersFormContext.Provider>
	);
};
